import { render } from "./NotFound.vue?vue&type=template&id=a8f595ba"
const script = {}

import exportComponent from "D:\\code\\svn\\malabs\\web\\web2021\\trunk\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__